/*
 * @Date: 2022-08-22 21:17:56
 * @LastEditors: kinfai
 * @Description: 机器人提示
 * @LastEditTime: 2022-08-23 17:33:24
 * @FilePath: \my-app\src\pages\RobetTip\index.jsx
 */
import "./index.less";
import AliIcon from "../../components/AliIcon";
import { Button } from "antd";
import { RouteContext } from "../../provide/route-context";

export default function RobetTip(props) {
  const tip = props.tip

  return (
    <RouteContext.Consumer>
      {(value) => {
        const changePage = () => {
          value.goPage("LeaveMsg");
          value.updateCsInfo(false);
        };

        return (
          <div className="g-web-chat-card">
            <div className="g-top-bar">
              <AliIcon type="icon-zhinengjiqirenmoban" size="35px" />
              <span className="s-robet-text">Robet</span>
            </div>
            <p style={{ marginTop: "5px" }}>
              {
                tip? tip : "It's not working hours yet. Please leave a message and our\n"
                    +
                    "customer service will contact you immediately."
              }
            </p>
            <Button shape="round" onClick={changePage}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    marginRight: "11px",
                  }}
                >
                  Leave a message
                </span>
                <AliIcon type="icon-fasong" size="18px" color="#4654a3" />
              </div>
            </Button>
          </div>
        );
      }}
    </RouteContext.Consumer>
  );
}
